import { X } from 'react-feather'
import { Modal, ModalBody } from 'reactstrap'
import FormAddCompanies from '../forms'

const ModalEdit = ({
  row,
  isOpenModalEdit,
  onHandleOpenCloseModalEdit,
  handleRefetch,
}) => {
  return (
    <Modal
      centered
      isOpen={isOpenModalEdit}
      toggle={() => onHandleOpenCloseModalEdit()}
      data-testid="companies-modal-edit"
    >
      <ModalBody>
        <div className="d-flex justify-content-between align-item-center">
          <h6>Ubah Data Perusahaan</h6>
          <X
            style={{ cursor: 'pointer' }}
            onClick={() => onHandleOpenCloseModalEdit()}
          />
        </div>
        <FormAddCompanies
          row={row}
          onHandleOpenCloseModalEdit={onHandleOpenCloseModalEdit}
          handleRefetch={handleRefetch}
        />
      </ModalBody>
    </Modal>
  )
}

export default ModalEdit
